let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8P4E7")).then(() => parcelRequire('2TK39'));